import { render } from "./CoolP5Comp.vue?vue&type=template&id=0794e442&scoped=true"
import script from "./CoolP5Comp.vue?vue&type=script&lang=js"
export * from "./CoolP5Comp.vue?vue&type=script&lang=js"

import "./CoolP5Comp.vue?vue&type=style&index=0&id=0794e442&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0794e442"]])

export default __exports__